jQuery(document).ready(function ($) {
    //############################################//
	//###*****   Component - Category filter dropdown    
	//############################################//  
    $('.js-post-filter').click(function () {
            
        //Close any other filters that are open
        var filterClass = $('.js-post-filter')
    
        var $this = $(this)

        $this.toggleClass('is-active');
        $this.closest('.c-post-filter__filter').find('.c-post-filter__menu').toggleClass('is-open').slideToggle(200);
        $this.closest('.c-post-filter__filter').find('.c-post-filter__arrow').toggleClass('is-open');		    

    })
})